if (!customElements.get('ef-review-slider')) {
  customElements.define('ef-review-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const viewport = this.querySelector('.ef-review-slider__viewport');
      const button = this.querySelector('button');
      const media = matchMedia('(prefers-reduced-motion: reduce)');
      const abort = new AbortController();
      const on = (target, name, fn) => target.addEventListener(name, fn, {signal: abort.signal});
      let paused = media.matches, hovering = false, focused = false, touching = false, visible = false;
      let frame, last = 0, direction = 1, resumeAt = 0, carry = 0;
      const updateButton = () => { button.setAttribute('aria-pressed', String(paused)); button.setAttribute('aria-label', paused ? 'Pornește derularea recenziilor' : 'Oprește derularea recenziilor'); button.textContent = paused ? '▶' : 'Ⅱ'; };
      button.hidden = false; updateButton();
      on(button, 'click', () => { paused = !paused; updateButton(); });
      on(this, 'mouseenter', () => { hovering = true; }); on(this, 'mouseleave', () => { hovering = false; });
      on(this, 'focusin', () => { focused = true; }); on(this, 'focusout', () => { focused = this.contains(document.activeElement); });
      on(viewport, 'pointerdown', () => { touching = true; });
      on(window, 'pointerup', () => { if(touching) resumeAt = performance.now()+3000; touching = false; });
      on(window, 'pointercancel', () => { touching = false; });
      on(viewport, 'wheel', () => { resumeAt = performance.now()+3000; });
      on(media, 'change', () => { paused = media.matches; updateButton(); });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }); observer.observe(this);
      const tick = now => {
        const elapsed = last ? Math.min(now-last,50) : 0; last = now;
        if (!paused && !hovering && !focused && !touching && visible && !document.hidden && now > resumeAt) {
          const max = viewport.scrollWidth - viewport.clientWidth;
          if(max > 1) {
            carry += elapsed * .025;
            const step = Math.floor(carry); carry -= step;
            viewport.scrollLeft += direction * step;
            if(viewport.scrollLeft >= max-1) { direction=-1;resumeAt=now+1300; }
            else if(viewport.scrollLeft <= 0 && direction < 0) { direction=1;resumeAt=now+1300; }
          }
        }
        frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
      this.cleanup = () => { cancelAnimationFrame(frame);observer.disconnect();abort.abort(); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup=null; }
  });
}
